import styled from '@emotion/styled';
import { Stack } from '@hotjar/hotsauce';

export const ObserveLimitsCardStyles = {
  CardBody: styled(Stack)`
    align-items: center;

    svg {
      // Fixes a visual bug in Chrome with parts of the traffic indicator SVG being cut off
      overflow: visible;
    }
  `,
};
